import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { context } from '@/Layout'
import { motion } from 'framer-motion'
import ArrowLinks from '@/components/shared/components/arrowLinks'
// styles
import './styles.ol.scss'

const ListLinks = (props) => {
  const { data } = props
  const { lenisInstance } = useContext(context)

  const scrollToAncor = (ancor_data) => {
    const id_for_to_anchor = get(ancor_data, ['id_for_to_anchor'], '')
    const target = document.getElementById(id_for_to_anchor)
    const duration_ancor = get(ancor_data, 'duration_ancor', 1)

    if (target) lenisInstance.scrollTo(target, { offset: -200, duration: Number(duration_ancor) })
  }

  return (
    <div className="containerLinks">
      {data.map((value, key) => (
        <motion.div
          style={{
            position: 'relative',
          }}
          transition={{
            duration: 0.6,
            delay: key * 0.3 + 0.3,
          }}
          viewport={{
            once: true,
          }}
          initial={{ opacity: 0, left: '70px' }}
          whileInView={{ opacity: 1, left: '0px' }}
          exit={{ opacity: 0 }}
          key={`link_${key}`}
          className="itemLink"
        >
          <ArrowLinks
            classNameLabel="uppercase leading-normal"
            isAnchor={value.is_ancor}
            textLink={
              value.is_ancor
                ? get(value.ancor_data, ['txt_ancor'], '')
                : get(value.link, ['title'], '')
            }
            href={!value.is_ancor ? get(value.link, ['url'], '') : ''}
            target={!value.is_ancor ? get(value.link, ['target'], '') : ''}
            altLink={!value.is_ancor ? `ALt_Link_${get(value.link, ['title'], '')}` : ''}
            onClick={() => {
              scrollToAncor(value.ancor_data)
            }}
          />
        </motion.div>
      ))}
    </div>
  )
}

ListLinks.propTypes = {
  data: PropTypes.array,
}

export default ListLinks
